import { useCallback, useContext, useMemo } from 'react';
import { env } from 'src/env';
import { QUERY_SEARCH_PARAM } from 'src/types';
import ThreadInputBoxContext from 'src/contexts/ThreadInputBoxContext';
import { useGetUser } from 'src/hooks/userHooks';

export const useRedirectToSNWithParams = () => {
  const { threadInputBoxValue, threadInputBoxFiles } = useContext(
    ThreadInputBoxContext,
  );

  const { isOpenTier } = useGetUser();
  const makeUrlWithRaw = useCallback((): string => {
    const baseURL = `${env.REACT_APP_SUPER_NINJA_URL}${!isOpenTier ? 'dashboard' : ''}`;
    const url = new URL(baseURL);

    if (threadInputBoxValue) {
      url.searchParams.set(QUERY_SEARCH_PARAM, threadInputBoxValue);
    }

    if (threadInputBoxFiles && Object.keys(threadInputBoxFiles).length > 0) {
      const filteredFileNames = Object.keys(threadInputBoxFiles)
        .filter(
          (key) =>
            !threadInputBoxFiles[key]?.errorMessage &&
            !!threadInputBoxFiles[key]?.convertedFileName,
        )
        .map((key) => threadInputBoxFiles[key]?.convertedFileName);

      filteredFileNames.forEach((fileName) => {
        fileName && url.searchParams.append('attachments[]', fileName);
      });
    }

    return url.toString();
  }, [isOpenTier, threadInputBoxValue, threadInputBoxFiles]);

  return useMemo(() => ({ href: makeUrlWithRaw() }), [makeUrlWithRaw]);
};
